import { render, staticRenderFns } from "./ConsultationsAnalytics.vue?vue&type=template&id=c951463a&scoped=true"
import script from "./ConsultationsAnalytics.vue?vue&type=script&lang=js"
export * from "./ConsultationsAnalytics.vue?vue&type=script&lang=js"
import style0 from "./ConsultationsAnalytics.vue?vue&type=style&index=0&id=c951463a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c951463a",
  null
  
)

export default component.exports